import React from "react";

function Button({ onClick, loading, label, className = "" }) {
  return (
    <button
      className={`btn mt-2 ${className}`}
      style={{
        backgroundColor: "#c33",
        borderColor: "#c33",
        color: "white",
        transition: "background-color 0.3s ease",
      }}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#a11")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#c33")}
      onClick={onClick}
      disabled={loading}
    >
      {loading ? "⏳ Преобразование..." : label}
    </button>
  );
}

export default Button;
